var $e43d964a0c7f1266$exports = {};
$e43d964a0c7f1266$exports = {
    "close": `Zatvori\u{165}`,
    "notifications": `Ozn\xe1menia`
};


export {$e43d964a0c7f1266$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
